import ConfirmDialog from '../widgets/dialog/ConfirmDialog';

export default class DeleteFirmwareDialog extends ConfirmDialog {

  title = () => 'آیا میخواهید این فایل را حذف کنید؟';

  icon = () => 'alert';

  message = () => {
    return (
      <>
        <hr />
        <div className="mr-auto">
          <button className="ant-btn" onClick={this.close}>خیر</button>
          <button className="ant-btn ant-btn-danger mr-1" onClick={this.onDeleteClick}>حذف</button>
        </div>
      </>
    );
  }

  private onDeleteClick = () => {
    this.close();
    this.resolve(true);
  }

}

